import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getMatches } from "../../services/matchService";
import { getLeagues } from "../../services/leagueService";
import {
  getAllBPointsGames,
  settleBPointsGame,
} from "../../services/bPointsGameResultService";

export const AddBPointsGamesResultLayer = () => {
  const [leagues, setLeagues] = useState([]);
  const [matches, setMatches] = useState([]);
  const [allGames, setAllGames] = useState([]);

  const [leagueId, setLeagueId] = useState("");
  const [matchId, setMatchId] = useState("");

  const [filteredMatches, setFilteredMatches] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);

  const [answers, setAnswers] = useState({});
  const [settleResult, setSettleResult] = useState({});

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [leagueRes, matchRes, gameRes] = await Promise.all([
        getLeagues(),
        getMatches(),
        getAllBPointsGames(),
      ]);

      if (leagueRes?.status) setLeagues(leagueRes.data || []);
      if (matchRes?.status) setMatches(matchRes.data || []);
      if (gameRes?.status) setAllGames(gameRes.data || []);
    } catch {
      toast.error("Failed to load data");
    }
  };

  useEffect(() => {
    if (!leagueId) {
      setFilteredMatches([]);
      setMatchId("");
      return;
    }

    const matchList = matches.filter(
      (m) => String(m.league_id) === String(leagueId)
    );

    setFilteredMatches(matchList);
    setMatchId("");
    setFilteredGames([]);
  }, [leagueId, matches]);

  useEffect(() => {
    if (!matchId) {
      setFilteredGames([]);
      return;
    }

    const games = allGames.filter(
      (g) =>
        String(g.match_id) === String(matchId) &&
        g.status === "active"
    );

    setFilteredGames(games);
    setAnswers({});
    setSettleResult({});
  }, [matchId, allGames]);

  const handleAnswerChange = (gameId) => {
    setAnswers({
      ...answers,
      [gameId]: "yes",
    });
  };

  const handleSubmit = async () => {
    if (!leagueId || !matchId) {
      toast.error("League & Match required");
      return;
    }

    const settlements = filteredGames.map((g) => ({
      game_id: g.id,
      match_id: Number(matchId),
      answer: answers[g.id] || "",
    }));

    if (settlements.some((s) => !s.answer)) {
      toast.error("Click Yes for all questions");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        league_id: Number(leagueId),
        settlements,
      };

      const res = await settleBPointsGame(payload);

      if (res?.status) {
        toast.success("Results submitted successfully");

        const resultMap = {};
        res.all_results.forEach((r) => {
          resultMap[r.game_id] = r;
        });

        setSettleResult(resultMap);
      } else {
        toast.error(res?.message || "Failed");
      }
    } catch {
      toast.error("Server error");
    }

    setLoading(false);
  };

  return (
    <div className="container-fluid mt-4">
      <div style={{padding:"30px"}} className="card shadow-sm ">

        <h5 className="mb-4">Declare B Points Game Results</h5>

        <div className="row mb-4">
          <div className="col-md-4 mb-3">
            <label>League</label>
            <select
              className="form-select"
              value={leagueId}
              onChange={(e) => setLeagueId(e.target.value)}
            >
              <option value="">Select League</option>
              {leagues.map((l) => (
                <option key={l.id} value={l.id}>
                  {l.league_name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-4 mb-3">
            <label>Match</label>
            <select
              className="form-select"
              value={matchId}
              onChange={(e) => setMatchId(e.target.value)}
              disabled={!leagueId}
            >
              <option value="">Select Match</option>
              {filteredMatches.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.team_a} vs {m.team_b}
                </option>
              ))}
            </select>
          </div>
        </div>

        {filteredGames.length > 0 && (
          <>
            <div className="table-responsive">
              <table className="table table-bordered text-center align-middle">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Question</th>
                    <th>Yes</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredGames.map((g, index) => {
                    const result = settleResult[g.id];

                    return (
                      <tr key={g.id}>
                        <td>{index + 1}</td>
                        <td className="text-start">{g.question}</td>
                        <td>
                          <button
                            className={`btn btn-sm ${
                              answers[g.id] === "yes"
                                ? "btn-success"
                                : "btn-outline-success"
                            }`}
                            onClick={() =>
                              handleAnswerChange(g.id)
                            }
                          >
                            Yes
                          </button>
                        </td>
                        <td>
                          {result ? (
                            result.status ? (
                              <span className="badge bg-success">
                                Success
                              </span>
                            ) : (
                              <span className="badge bg-warning text-dark">
                                No Entries
                              </span>
                            )
                          ) : answers[g.id] ? (
                            <span className="badge bg-info">
                              Selected
                            </span>
                          ) : (
                            <span className="text-muted">
                              Pending
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <button
              className="btn btn-primary w-100 mt-3"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit All Results"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};